import * as React from "react";
import LoadingProgress from "../../components/Misc/LoadingProgress";
// This is a Custom Callback component for oidc-client
const CustomCallback = () => (
    <LoadingProgress />
);

export default CustomCallback;
